export default {
  getTypesDictionary: (axios) => axios.get('/api/cars/dictionaries/types'),
  getMakesDictionary: (axios, carTypeId) =>
    axios.get('/api/cars/dictionaries/makes', { params: { carTypeId } }),
  getModelsDictionary: (axios, carTypeId, makeId) =>
    axios.get('/api/cars/dictionaries/models', {
      params: { carTypeId, makeId },
    }),
  getVersionsDictionary: (axios, modelId) =>
    axios.get('/api/cars/dictionaries/versions', { params: { modelId } }),
}
